module.exports = __webpack_public_path__ + "img/Titel.afce4f28.png";